document.addEventListener("DOMContentLoaded", function () {
  const stickyAtc = document.getElementById("StickyATC");
  const atcButton = document.querySelector('.product-form__submit[name="add"]');
  const stickyButton = document.querySelector(".sticky-atc__button");

  if (!stickyAtc || !atcButton || !stickyButton) return;

  // --- show/hide sticky ATC ---
  const toggleStickyVisibility = (isIntersecting, rect) => {
    const isAboveViewport = rect
      ? rect.top < 0
      : window.scrollY > atcButton.offsetTop;

    if (!isIntersecting && isAboveViewport) {
      stickyAtc.classList.add("show");
    } else {
      stickyAtc.classList.remove("show");
    }
  };

  // Initial Check for Page Refresh
  setTimeout(() => {
    const initialRect = atcButton.getBoundingClientRect();
    const isInitialVisible =
      initialRect.top >= 0 && initialRect.bottom <= window.innerHeight;
    toggleStickyVisibility(isInitialVisible, initialRect);
  }, 100);

  // Continuous Observer for Scrolling
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        toggleStickyVisibility(entry.isIntersecting, entry.boundingClientRect);
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -120px 0px",
    },
  );
  observer.observe(atcButton);

  // --- Sticky Add to cart functionality -----
  stickyButton.addEventListener("click", function (e) {
    e.preventDefault();
    const variantId = stickyButton.dataset.variantId;
    const loaderEl = stickyButton.querySelector(".product-card__spinner");
    if (loaderEl) loaderEl.classList.remove("hidden");

    const formData = {
      id: variantId,
      quantity: 1,
      sections: "cart-drawer,cart-icon-bubble",
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        const cartDrawer = document.querySelector("cart-drawer");

        if (cartDrawer) {
          if (cartDrawer.classList.contains("is-empty")) {
            cartDrawer.classList.remove("is-empty");
          }
          cartDrawer.renderContents(data);
          cartDrawer.open();
        }

        setTimeout(() => {
          loaderEl.classList.add("hidden");
        }, 100);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        loaderEl.classList.add("hidden");
      });
  });
});
